<template>
  <div>
    <div v-if="!loggedIn"
         class="col-12">
      <p>
        <strong>To subscribe you must be logged in first.</strong>
      </p>
    </div>

    <div v-if="loggedIn">
      <form @submit.prevent="onSubmit">
        <div class="col-12">
          <p>
            <button class="btn btn-accent-2 btn-subscribe"
                    type="submit"
                    :disabled="submitted">
              <template v-if="loading">
                <font-awesome-icon icon="spinner"
                                   spin></font-awesome-icon>
              </template>
              <template v-else-if="submitted">
                Requested!
              </template>
              <template v-else-if="error">
                <font-awesome-icon :icon="['far', 'times']"></font-awesome-icon>
                Error
              </template>
              <template v-else>
                {{ getButtonText() }}
              </template>
            </button>
          </p>
        </div>
        <div v-if="submitted"
             class="col-12">
          <p>
            Thank you for requesting this subscription.
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { requestOrgSubscription } from "~/Scripts/resources/subscriptionResource";

export default {
  name: "SubscriptionOrgRequester",
  props: {
    name: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    bookmark: {
      type: String,
      default: null,
    },
    loggedIn: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      submitted: false,
      loading: false,
      error: false,
    };
  },
  methods: {
    getButtonText () {
      let text;
      if ( this.buttonText && this.buttonText.length > 0 ) {
        text = this.buttonText;
      } else {
        text = `Subscribe to ${this.name}`;
      }
      return text;
    },
    onSubmit () {
      this.loading = true;

      requestOrgSubscription( this.name, this.url, this.bookmark )
        .then( ( response ) => {
          if ( response && response.data ) {
            this.submitted = true;
          } else {
            this.error = true;
          }
        } )
        .catch( () => {
          this.error = true;
        } )
        .finally( () => {
          this.loading = false;
        } );
    },
  },
};
</script>
